export default __webpack_public_path__ + "static/media/bg1.5cbc690c.png";